// src/app/app.config.ts
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';

import { Title } from '@angular/platform-browser';
import { routes } from './app.routes';
import { EventManagerService } from './shared/event-manager.service';

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(routes),
        provideAnimations(),
        provideHttpClient(withInterceptorsFromDi()),
        Title,
        EventManagerService,

    ],
};